import React, { useState, useRef, useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { EasyBefore, Logo, tick } from "../../constant/Index";
import "../../assets/Css/completeyourprofile.css";
import compprofile from "../../assets/img/completeprofile.png";
import bottomimg from "../../assets/img/botttom_img2.png";
import { useNavigate } from "react-router-dom";
import { useForm } from "../../hooks/Form";
import { ToastMessage } from "../../utils/ShowToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { setSuccess, clearMessage } from "../../store/reducers/globalReducers";
import { useCompleteYourProfileMutation } from "../../store/services/EditDrivingService.js";
import { useGetProfileQuery } from "../../store/services/AuthServices";

const CompleteYourProfile = () => {
	const { user } = useSelector((state) => state.AuthReducer);
	const [errors, setErrors] = useState([]);
	const { state, onChange, setState } = useForm({
		first_name: "",
		last_name: "",
		email: "",
		contact_no: "",
		date: "",
		age: "",
		address: "",
		driver_license_info: "",
		rut: "",
		company_details: "",
		revenue: "",
	});
	let { success } = useSelector((state) => state.globalReducer);
	const [driverProfile, response] = useCompleteYourProfileMutation();
	let { data, isFetching } = useGetProfileQuery();
	let usersDetails = data?.response?.data;
	const ref = useRef();
	console.log(response.isLoading, "::::::::");
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [newFile, setNewFile] = useState("");
	const [fileupload, setFileupload] = useState(user?.image);
	const [uploadLoading, setUploadLoading] = useState(false);
	const handleImageUpload = (e) => {
		e.preventDefault();
		const reader = new FileReader();
		const file = e.target.files[0];
		reader.onloadend = () => {
			setNewFile(file);
			setFileupload(reader.result);
		};
		reader.readAsDataURL(file);
		setUploadLoading(true);
	};

	useEffect(() => {
		setState(usersDetails);
	}, [isFetching === true]);

	const onSubmit = (e) => {
		e.preventDefault();
		if (
			!state.first_name ||
			!state.last_name ||
			!state.email ||
			!state.contact_no ||
			!state.date ||
			!state.age ||
			!newFile ||
			!state.address ||
			!state.driver_license_info ||
			!state.rut ||
			!state.company_details ||
			!state.revenue
		) {
			ToastMessage("Please Fill All fields");
		} else if (state?.rut?.length < 12 || state?.rut?.length > 12) {
			ToastMessage("Please Enter only 12 number in Rut");
		} else {
			const FormDatas = new FormData();
			FormDatas.append("first_name", state.first_name);
			FormDatas.append("last_name", state.last_name);
			FormDatas.append("email", state.email);
			FormDatas.append("contact_no", state.contact_no);
			FormDatas.append("avatar", newFile);
			FormDatas.append("dob", state.date);
			FormDatas.append("age", state.age);
			FormDatas.append("address", state.address);
			FormDatas.append("driver_license_info", state.driver_license_info);
			FormDatas.append("rut", state.rut);
			FormDatas.append("company_details", state.company_details);
			FormDatas.append("revenue", state.revenue);
			driverProfile(FormDatas);
		}
	};

	useEffect(() => {
		if (success !== "") {
			ToastMessage(
				success === "responseMessages.driverProfileAdded"
					? "Profile Update Successfully"
					: success,
			);
			state.first_name = "";
			state.last_name = "";
			state.email = "";
			state.contact_no = "";
			state.date = "";
			state.age = "";
			state.address = "";
			state.driver_license_info = "";
			state.rut = "";
			state.company_details = "";
			state.revenue = "";
			navigate("/driver-profile");
		}
		return () => {
			dispatch(clearMessage());
		};
	}, [success]);

	console.log(response?.error?.data?.message);

	useEffect(() => {
		if (response?.error?.data?.message === "Driver Profile already added") {
			ToastMessage(response?.error?.data?.message);
		}
	}, [response?.error?.data?.message]);

	useEffect(() => {
		if (response.isError) {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data?.errors]);

	useEffect(() => {}, []);

	useEffect(() => {
		if (response.isSuccess) {
			setErrors([]);
			dispatch(setSuccess(response?.data?.message));
		}
	}, [response.isSuccess]);
	return (
		<>
			{/* modal starts here */}
			{/* <div
				className="modal fade"
				id="exampleModal"
				tabindex="-1"
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-body">
							<div className="thank-you-wrapper">
								<div className="thank-you-img-wrapper">
									<figure>
										<img src={tick} alt="" />
									</figure>
								</div>
								<div className="thank-you-content-wrapper">
									<h3>Thank You!</h3>
									<h4>For Signing Up in Flit</h4>
									<h6>Please Check Your email to continue</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> */}
			{/* modal ends here */}
			{/* <!-- complete your profile Page Start Here --> */}
			{/* Header Start Here */}
			{/* Header End Here */}
			<section className="comprofile_Sec ">
				<div className="right-before">
					<figure>
						<img src={EasyBefore} alt="" className="img-fluid" />
					</figure>
				</div>
				<div className="container-fluid">
					<div className="row align-items-center">
						<div className="col-lg-4"></div>
						<div className="col-lg-4 p-0">
							<div className="logo-wrapper">
								<figure>
									<img src={Logo} alt="" />
								</figure>
							</div>
							<div className="signInBox">
								<div className="title">
									<h1>Complete Your Profile</h1>
								</div>

								<div className="taglines pb-3">
									<p>
										Please fill the information below to complete your profile
									</p>
								</div>
								<div className="compprofile_img">
									<label for="upload-photo">
										{uploadLoading ? (
											<img src={fileupload} className="img-fluid" alt="" />
										) : (
											<figure>
												<img src={compprofile} className="img-fluid" alt="" />
											</figure>
										)}
										<label className="upload_btn" for="upload-photo">
											Upload Image
										</label>
									</label>
									<input
										type="file"
										id="upload-photo"
										name=""
										value=""
										onChange={handleImageUpload}
										multiple="false"
										accept="image/*"
									/>
								</div>
								<form>
									<div className="text-center">
										<h4>Personal Detail</h4>
									</div>
									<div className="form-group">
										<input
											type="text"
											className={`${
												errors && errors?.first_name
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="John"
											name="first_name"
											value={state?.first_name}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.first_name && (
										<span className="errorMessage">
											<p>{errors && errors?.first_name}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="text"
											className={`${
												errors && errors?.last_name
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder=" Doe"
											name="last_name"
											onChange={onChange}
											value={state?.last_name}
										/>
									</div>
									{errors && errors?.last_name && (
										<span className="errorMessage">
											<p>{errors && errors?.last_name}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="email"
											className={`${
												errors && errors?.email
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="Johndoe@gmail.com"
											name="email"
											value={state?.email}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.email && (
										<span className="errorMessage">
											<p>{errors && errors?.email}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="number"
											className={`${
												errors && errors?.contact_no
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="Contact Number"
											name="contact_no"
											value={state?.contact_no}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.contact_no && (
										<span className="errorMessage">
											<p>{errors && errors?.contact_no}</p>
										</span>
									)}
									<div className="text-center my-4">
										<h4>Driving details </h4>
									</div>

									<div className="form-group">
										<input
											type="text"
											placeholder="D.O.B"
											ref={ref}
											onFocus={() => (ref.current.type = "date")}
											required
											onChange={onChange}
											value={state?.date}
											name="date"
											// min={new Date().toISOString().split("T")[0]}
											className="form-control"
										/>
										{/* <input
											type="text"
											className={`${
												errors && errors?.dob
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="D.O.B"
											name="dob"
											value={state?.dob}
											onChange={onChange}
										/> */}
									</div>
									{errors && errors?.dob && (
										<span className="errorMessage">
											<p>{errors && errors?.dob}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="tel"
											className={`${
												errors && errors?.age
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="Age"
											name="age"
											value={state?.age}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.age && (
										<span className="errorMessage">
											<p>{errors && errors?.age}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="text"
											className={`${
												errors && errors?.address
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="Address"
											name="address"
											value={state?.address}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.address && (
										<span className="errorMessage">
											<p>{errors && errors?.address}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="text"
											className={`${
												errors && errors?.driver_license_info
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="Driver’s License Info"
											name="driver_license_info"
											value={state?.driver_license_info}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.driver_license_info && (
										<span className="errorMessage">
											<p>{errors && errors?.driver_license_info}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="text"
											className={`${
												errors && errors?.rut
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="RUT"
											name="rut"
											value={state?.rut}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.rut && (
										<span className="errorMessage">
											<p>{errors && errors?.rut}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="text"
											className={`${
												errors && errors?.company_details
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="Company Details"
											name="company_details"
											value={state?.company_details}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.company_details && (
										<span className="errorMessage">
											<p>{errors && errors?.company_details}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="text"
											className={`${
												errors && errors?.revenue
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											placeholder="Revenue"
											name="revenue"
											value={state?.revenue}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.revenue && (
										<span className="errorMessage">
											<p>{errors && errors?.revenue}</p>
										</span>
									)}
									<div className="col-md-12 px-0 text-right mt-5 pt-2">
										<button
											className="btn btn-secondary btnn signup-btn rounded-pill full"
											type="button"
											onClick={onSubmit}
										>
											{response?.isLoading ? "Loading..." : "Save Changes"}
										</button>
									</div>
									<div className="col-md-12 px-0 text-right mt-3">
										<button
											className="btn btn-secondary btnn signup-btn rounded-pill n-visible full"
											type="button"
											onClick={() => navigate("/account")}
										>
											Skip for Now
										</button>
									</div>
								</form>
							</div>
						</div>
						<div className="col-lg-4"></div>
					</div>
				</div>
				<div className="bottom_before">
					<img src={bottomimg} className="img-fluid" alt="" />
				</div>
			</section>
			{/* <!-- Sign In Page End Here --> */}
			{/* Header Start Here */}
			{/* Header End Here */}
		</>
	);
};

export default CompleteYourProfile;
